// import { UserSearchResponse, UserSearchFilter, User, SignupRequest } from '@api/entities';
import { SignupRequest, User, UserSearchFilter, UserSearchResponse } from 'src/api/entities';
import { IUserApiService, UserApiService } from '../services/user/user.api.service';

export interface IUserManager {
    search(page: number, size: number, query?: string, sort?: { [key: string]: string | undefined }, filter?: UserSearchFilter): Promise<UserSearchResponse>;
}

export class UserManager implements IUserManager {
    private static instance: UserManager;
    private userService: IUserApiService;

    private constructor() {
        this.userService = UserApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (UserManager.instance == null) {
            UserManager.instance = new UserManager();
        }
        return UserManager.instance;
    }

    async search(): Promise<UserSearchResponse> {
      const filter : UserSearchFilter = {
        role: 'ROLE_PERSONAL',
      }  
      
      const response: UserSearchResponse = await this.userService.search(
          0, 
          100, 
          undefined, 
          undefined, 
          filter
        );
        return response;
    }

    async getUserById(id: number): Promise<User> {
        const response = await this.userService.getUserById(id)
        return response;
      }
    async delete(email: string): Promise<{[key: string]: boolean}> {
        const response = await this.userService.delete(email)
        return response;
      }
    async create(request: SignupRequest): Promise<User> {
        const response = await this.userService.create(request)
        return response;
      }
}
